import { memo } from 'react';

import { IcPlay16Icon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import SelectedText from '../../SelectedText';
import styles from './styles.m.scss';

const Video = ({ message }) => {
  return (
    <>
      <IconView
        Icon={IcPlay16Icon}
        size="small"
        className={styles.icon}
      />
      <SelectedText {...message.textChunk} />
    </>
  );
};

export default memo(Video);
